// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


// import Menu from "./components/menu/menu.jsx";

// function App() {

//     return (
//         <Menu />
//     );

// }

// export default App;


import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Menu from "./components/menu/menu";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Home */}
        <Route path="/" element={<Menu />} />

        {/* Menu */}
        <Route path="/menu" element={<Menu />} />

        {/* Any other route */}
        <Route path="*" element={<Navigate to="/menu" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;